import { useQuery } from '@tanstack/react-query';
import { apiRequest } from './apiClient';

export interface SocialLinks {
  linkedin: string;
  twitter: string;
  github: string;
  youtube: string;
}

export interface PublicSiteSettings {
  logoUrl: string | null;
  address: string;
  phone: string;
  contactEmail: string;
  salesEmail: string;
  socialLinks: SocialLinks;
}

function fetchSiteSettings() {
  return apiRequest<PublicSiteSettings>('/settings');
}

/**
 * Admin-managed site settings (logo, contact info, social links). Every call
 * site falls back to the hardcoded `constants/site.ts` defaults while this
 * is loading or if it fails — the public site's Footer/Logo render on every
 * page and must never block or blank out on this request.
 */
export function useSiteSettings() {
  return useQuery({
    queryKey: ['site-settings'],
    queryFn: fetchSiteSettings,
    staleTime: 5 * 60_000,
    retry: 1,
  });
}
